import { Toast } from 'mint-ui'

let caches = []
const getEnvironment = () => {
  let u = window && window.navigator.userAgent
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  return {
    isAndroid,
    isiOS
  }
}
const generateFunc = (func, payload = '') => {
  if (getEnvironment().isiOS && window.webkit) {
    try {
      window.webkit.messageHandlers[func].postMessage(payload)
    } catch (e) {
      for (let i = 0; i < caches.length; i++) {
        typeof caches[i] == 'function' && caches[i]()
      }
      caches = []
    }
    return false
  }
  if (getEnvironment().isAndroid && window.webViewObj) {
    window.webViewObj[func](payload)
    return false
  }
  for (let i = 0; i < caches.length; i++) {
    typeof caches[i] == 'function' && caches[i]()
  }
  caches = []
}

export default function({ store, ...context }) {
  const Vm = store._vm

  context.$axios.onError(error => {
    generateFunc('errorOccur', '加载出错')
    error.response.data && Toast(error.response.data.msg || '服务器未知错误')
  })
  context.$axios.onResponse(response => {
    if (
      response.data &&
      response.data.msg &&
      !response.data.success &&
      process.client
    ) {
      window.uiInstance = Toast(response.data.msg)
    } else {
      window.uiInstance = { close() {} }
    }
  })
  if (process.env.API_URL) {
    context.$axios.defaults.baseURL = process.env.API_URL
  }
  context.$axios.setHeader('App-Key', 'DoctorWeb')

  // 注册状态回调
  context.$axios.onRequest(async config => {
    await Vm.$bridge.login()
    const token = window.localStorage.getItem('token')
    config.headers.Authorization = `Bearer ${token}`
    if (config.url.slice(0, 4) === '/jav' && process.env.JAVA_URL) {
      config.url = config.url.slice(4)
      config.baseURL = process.env.JAVA_URL

      // 测试专用 begin ******
      let JAVA_URL = ''
      if (process.client) {
        JAVA_URL = window.localStorage.getItem('JAVA_URL')
      }
      config.baseURL = JAVA_URL || process.env.JAVA_URL
      // 测试专用 end ******
    }
    return config
  })
}
